import { datadogRum } from "@datadog/browser-rum";
import React from "react";
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError(error) {
        datadogRum.addError(error);
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        this.setState({
            hasError: true,
        });
        datadogRum.addError(error, errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return null;
        }
        else
            return this.props.children;
    }
}
const redactUrl = (url) => url?.replace(/[#?][^&]*/, "query_params=REDACTED");
const datadogInit = ({ partner, applicationId, clientToken, service, version, environment = "development", }) => {
    datadogRum.init({
        env: environment,
        applicationId,
        clientToken,
        service,
        version,
        site: "datadoghq.eu",
        silentMultipleInit: true,
        sampleRate: 100,
        trackInteractions: false,
        defaultPrivacyLevel: "mask",
        beforeSend: (event) => {
            // remove query and hash from view url (GDPR)
            event.view.url = redactUrl(event.view.url);
            event.view.referrer = redactUrl(event.view.referrer);
            if (event.type === "resource") {
                event.resource.url = redactUrl(event.resource.url);
            }
            if (event.type === "error" && event.error.resource) {
                event.error.resource.url = redactUrl(event.error.resource.url);
            }
        },
    });
    datadogRum.addRumGlobalContext("partner", partner);
};
export { ErrorBoundary, datadogInit };
